import gsap from 'gsap';

const siteNavigation = () => {

  const hamburger = document.querySelector('#hamburger');

  if (!hamburger) return false;

  hamburger.addEventListener('click', toggleNav, false);

  function toggleNav() {

    const hamburger = this;
    const nav = document.querySelector('.overlay-nav');
    const headerLogos = document.querySelectorAll('.site-header__logo');
    const body = document.getElementsByTagName('body')[0];
    // const TL = gsap.timeline();

    if (!hamburger.classList.contains('is-active')) {

      hamburger.classList.add('is-active');
      body.classList.add('lite');
      nav.classList.add('is-active');

      headerLogos.forEach(el => {
        el.style.opacity = 0;
      });

      // TL.to(nav.querySelectorAll('a'), {
      //   duration: 1,
      //   y: 0,
      //   autoAlpha: 1,
      //   ease: "sine"
      // });


    } else {

      setTimeout(() => {
        hamburger.classList.remove('is-active');
        body.classList.remove('lite');
        nav.classList.remove('is-active');
        headerLogos.forEach(el => {
          el.removeAttribute('style');
        });
      }, 1500);

      // TL.to(nav.querySelectorAll('a'), {
      //   duration: 1,
      //   y: '10%',
      //   autoAlpha: 0,
      //   ease: "sine"
      // });

    }

  } // END toggleNav

  /**
   * Extended Navigation
   * Force parent links not to link to allow access to sub items
   * Add active state to sub menus
   */
  let navHasChildren = document.querySelectorAll('.overlay-nav ul li.menu-item-has-children');

  for (let i = 0; i < navHasChildren.length; i++) {

    // Add active class to dropdown onclick
    navHasChildren[i].addEventListener('click', showChildren, false);
    navHasChildren[i].addEventListener('mouseenter', showChildren, false);
    navHasChildren[i].addEventListener('mouseleave', hideChildren, false);

    function showChildren(e) {
      e.stopPropagation();
      navHasChildren[i].classList.add('is-active');
    } // END toggleChildren

    function hideChildren(e) {
      e.stopPropagation();
      navHasChildren[i].classList.remove('is-active');
    }

    // Add class to parent level links
    navHasChildren[i].querySelector('a').classList.add('is-parent');

    const isParent = document.querySelectorAll('a.is-parent');

    // Disable click for parent level links to allow access to sub items
    for (let i = 0; i < isParent.length; i++) {
      isParent[i].addEventListener("click", clickHandler);

      let clickCounter = null;

      function clickHandler(e) {

        // Check if mobile device
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {

          if (clickCounter == null) {
            e.preventDefault();
            clickCounter = setTimeout(function () {
              clickCounter = null;
            }, 500);
          } else {
            clearTimeout(clickCounter);
            clickCounter = null;
          }

        }
      } // END clickHandler
    }
  }

};

export default siteNavigation;